<template>
    <div >
        <div :id="'Div' + nomeFormulario" :name="'Div' + nomeFormulario">
            <form :method="metodoFormulario" :action="linkAction" :id="nomeFormulario" :name="nomeFormulario" @submit.prevent="!visualizar && insereOuAtualiza()" novalidate>
                <div v-if="!edit">
                    <slot name="csrf">

                    </slot>
                </div>
                <input type="hidden" name="id_empresa" :value="curso.id">

                <fieldset class="ec-form-secao">
                    <legend><b-icon icon="journal-bookmark"></b-icon> Dados do curso</legend>
                    <div class="form-row">
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="inputCodigoCurso">Código do curso</label>
                            <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.codigocurso }" id="inputCodigoCurso" name="inputCodigoCurso" placeholder="Ex.: 120" v-model="curso.codigocurso">
                            <div class="invalid-feedback" v-if="errors.codigocurso">{{ errors.codigocurso[0] }}</div>
                        </div>
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="inputCodigoIdentificacao">Código de identificação</label>
                            <input :readonly="visualizar" type="text" class="form-control" :class="{ 'is-invalid': errors.codigoidentificacao }" id="inputCodigoIdentificacao" name="inputCodigoIdentificacao" placeholder="Código de identificação" v-model="curso.codigoidentificacao">
                            <div class="invalid-feedback" v-if="errors.codigoidentificacao">{{ errors.codigoidentificacao[0] }}</div>
                        </div>
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="tipocurso">Tipo de curso</label>
                            <input :readonly="visualizar" type="text" class="form-control" :class="{ 'is-invalid': errors.tipocurso }" id="tipocurso" name="tipocurso" placeholder="Tipo de curso" v-model="curso.tipocurso">
                            <div class="invalid-feedback" v-if="errors.tipocurso">{{ errors.tipocurso[0] }}</div>
                        </div>
                        <div class="form-group col-sm-6 col-lg-3 ec-campo-switch">
                            <label for="cadastroAtivo">Situação</label>
                            <b-form-checkbox id="cadastroAtivo" v-model="curso.ativo" name="cadastroAtivo" :value="'Ativo'" :unchecked-value="'Inativo'" :disabled="visualizar" :switch="true">
                                {{ curso.ativo=='Ativo' ? 'Ativo' : 'Inativo' }}
                            </b-form-checkbox>
                        </div>
                        <div class="form-group col-lg-6">
                            <label for="inputDescricaoCurso">Nome do curso</label>
                            <input :readonly="visualizar" type="text" class="form-control" :class="{ 'is-invalid': errors.descricaocurso }" id="inputDescricaoCurso" name="inputDescricaoCurso" placeholder="Nome completo do curso" v-model="curso.descricaocurso">
                            <div class="invalid-feedback" v-if="errors.descricaocurso">{{ errors.descricaocurso[0] }}</div>
                        </div>
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="inputDescricaoDocumento">Nome reduzido</label>
                            <input :readonly="visualizar" type="text" class="form-control" :class="{ 'is-invalid': errors.descricaodocumento }" id="inputDescricaoDocumento" name="inputDescricaoDocumento" placeholder="Usado nos documentos" v-model="curso.descricaodocumento">
                            <div class="invalid-feedback" v-if="errors.descricaodocumento">{{ errors.descricaodocumento[0] }}</div>
                        </div>
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="inputPeriodo">Período</label>
                            <input :readonly="visualizar" type="text" class="form-control" :class="{ 'is-invalid': errors.periodo }" id="inputPeriodo" name="inputPeriodo" placeholder="Ex.: Manhã" v-model="curso.periodo">
                            <div class="invalid-feedback" v-if="errors.periodo">{{ errors.periodo[0] }}</div>
                        </div>
                    </div>
                </fieldset>

                <div class="ec-form-acoes">
                    <button v-if="!visualizar && curso.tokenapirubeus" :disabled="curso.idexportacaocrm > 0 || curso.id==''" type="button" class="btn btn-outline-primary" @click="exportarEmpresaCrm(curso)"><b-icon icon="cloud-upload"></b-icon> Exportar para Rubeus</button>
                    <a :href="'/'+urlSistema" class="btn btn-outline-primary">{{ visualizar ? 'Voltar' : 'Cancelar' }}</a>
                    <button v-if="!visualizar" type="submit" class="btn btn-primary"><b-icon icon="check2"></b-icon> Salvar</button>
                </div>
            </form>
        </div>
        <modal-component titulo="Mensagem do Sistema" label-btn-fechar="OK" id="MensagemSistema" :url-redirect="'/'+urlSistema+'/'" :sem-padding="true">
            <template v-slot:titulo>
            </template>
            <template v-slot:conteudo>
                <div class="alert alert-success text-center rounded-0 mb-0" role="alert">
                    <b-icon icon="check-circle-fill"></b-icon>
                    <b>{{ edit ? 'Atualizado com sucesso!' : 'Cadastrado com sucesso!' }}</b>
                </div>
                <table class="table table-sm mb-0 cc-detalhes">
                    <caption class="sr-only">Dados do registro salvo</caption>
                    <thead class="ec-thead">
                        <tr><th colspan="2" class="text-center">Curso</th></tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">ID</th>
                            <td>{{ curso.id }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Nome</th>
                            <td>
                                <template v-if="curso.nomecompleto">{{ curso.nomecompleto }}</template>
                                <span v-else class="ec-tabela__vazio">—</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">CNPJ</th>
                            <td>
                                <template v-if="curso.cnpj">{{ curso.cnpj }}</template>
                                <span v-else class="ec-tabela__vazio">—</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </modal-component>
        <modal-component titulo="Exportação CRM" label-btn-fechar="OK" id="ExportacaoCrmMsg" :url-redirect="'/'+urlSistema+'/'" :sem-padding="true">
            <template v-slot:titulo>
                Exportação CRM
            </template>
            <template v-slot:conteudo>
                <div class="alert alert-success text-center rounded-0 mb-0" role="alert">
                    <b-icon icon="check-circle-fill"></b-icon>
                    <b>Curso exportado para o CRM</b>
                </div>
                <table class="table table-sm mb-0 cc-detalhes">
                    <caption class="sr-only">Dados da exportação para o CRM</caption>
                    <thead class="ec-thead">
                        <tr><th colspan="2" class="text-center">Curso</th></tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Código</th>
                            <td>{{ empresa_exportada_crm.codigoempresa }}</td>
                        </tr>
                        <tr>
                            <th scope="row">ID de exportação</th>
                            <td>{{ empresa_exportada_crm.idexportacaocrm }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Descrição da unidade</th>
                            <td>{{ empresa_exportada_crm.nomecompleto }}</td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </modal-component>
        <section :id="'DivTable' + nomeFormulario" :name="'DivTable' + nomeFormulario" class="cc-turmas">
            <h3 class="cc-turmas__titulo">
                <b-icon icon="people"></b-icon> Turmas vinculadas ao curso
                <span class="cc-turmas__contagem">{{ turmasCurso.length }}</span>
            </h3>
            <div class="table-responsive">
                <table v-ec-datatable class="table table-sm table-hover ec-tabela">
                    <thead class="ec-thead">
                        <tr>
                            <th class="text-left">Turma</th>
                            <th class="text-center">Oferta</th>
                            <th class="text-center">Ano</th>
                            <th class="text-center">Início</th>
                            <th class="text-center">Término</th>
                            <th class="text-center">Início inscrição</th>
                            <th class="text-center">Término inscrição</th>
                            <th class="text-center">Vagas</th>
                            <th class="text-center">Situação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="turma,i in turmasCurso" :key="i">
                            <td class="text-left" data-label="Turma">
                                <span class="ec-tabela__principal">{{ turma.descricaoturma || '—' }}</span>
                                <small v-if="turma.descricaociclo" class="ec-tabela__secundario">{{ turma.descricaociclo }}</small>
                            </td>
                            <td class="text-center" data-label="Oferta">
                                <template v-if="turma.codigooferta">{{ turma.codigooferta }}</template>
                                <span v-else class="ec-tabela__vazio">—</span>
                            </td>
                            <td class="text-center" data-label="Ano">
                                <template v-if="turma.anoinicio">{{ turma.anoinicio }}</template>
                                <span v-else class="ec-tabela__vazio">—</span>
                            </td>
                            <td class="text-center" data-label="Início">{{ formatDate(turma.datainicio,2) || '—' }}</td>
                            <td class="text-center" data-label="Término">{{ formatDate(turma.datatermino,2) || '—' }}</td>
                            <td class="text-center" data-label="Início inscrição">{{ formatDate(turma.datainicioinscricao,2) || '—' }}</td>
                            <td class="text-center" data-label="Término inscrição">{{ formatDate(turma.dataterminoinscricao,2) || '—' }}</td>
                            <td class="text-center" data-label="Vagas">
                                <template v-if="vagasTurma(turma)">{{ vagasTurma(turma) }}</template>
                                <span v-else class="ec-tabela__vazio">—</span>
                            </td>
                            <td class="text-center" data-label="Situação">
                                <span v-if="turma.situacaoturma" class="ec-status ec-status--neutro">{{ turma.situacaoturma }}</span>
                                <span v-else class="ec-tabela__vazio">—</span>
                            </td>
                        </tr>
                        <tr v-if="turmasCurso.length==0">
                            <td colspan="9" class="ec-tabela__estado">
                                <b-icon icon="inbox" font-scale="2"></b-icon>
                                <p>Nenhuma turma vinculada a este curso.</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>
</template>

<script>


export default{

    computed:{
        // turmas do curso (lista vazia quando o curso ainda não tem turmas carregadas)
        turmasCurso(){
            return (this.curso && this.curso.school_classes) || []
        },
    },
    methods:{
        // "Mín. 10 · Máx. 40"; null quando a turma não informa tamanho
        vagasTurma(turma){
            const informado = valor => valor !== null && valor !== undefined && valor !== '' && Number(valor) >= 0
            const partes = []
            if(informado(turma.tamanhoturmaminimo)) partes.push('Mín. ' + turma.tamanhoturmaminimo)
            if(informado(turma.tamanhoturmaximo)) partes.push('Máx. ' + turma.tamanhoturmaximo)
            return partes.length ? partes.join(' · ') : null
        },
        dissmiss(id){
            this.$bvModal.hide(id);
        },
        novo(id){
            this.user = {}
            this.modoeditar = false
            this.modoexcluir = false
            this.modonovo = true
            this.texto_modal = "Novo"
            this.user.id=id
            // console.log(this.user)
        },
        editar(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = true
            this.modoexcluir = false
            this.modonovo = false
            this.texto_modal = "Editar"
            // console.log(this.user)
            // console.log(this.user)
        },
        excluir(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = false
            this.modoexcluir = true
            this.modonovo = false
            this.texto_modal = "Excluir"
            // console.log(this.user)
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        resetModal() {
            this.name = ''
            this.nameState = null
        },
        removerPorId: function (id) {
            var _vm = this; //Adicionando a instância à uma variável, para que possa ser acessada dentro do forEach`
            this.users.forEach(function(el, index) {
                if(el.id === id)
                    _vm.users.splice(index, 1);
            })
        },
        insereOuAtualiza(){
            if(!this.edit){
                this.inserirCompany();
                console.log('insere')
            }else{
                this.atualizaCompany();
                console.log('atualiza')
            }
        },
        inserirCompany(){
            // if(this.modonovo){
                let url='/api/v1/'+this.urlSistema;
                console.log(url)
                let formData = new FormData();
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('codigoempresa', (this.curso.codigoempresa?this.curso.codigoempresa:''))
                formData.append('nomecompleto', (this.curso.nomecompleto?this.curso.nomecompleto:''))
                formData.append('cnpj', (this.curso.cnpj?this.curso.cnpj:''))
                formData.append('periodo', (this.curso.periodo?this.curso.periodo:''))
                formData.append('tipocurso', (this.curso.tipocurso?this.curso.tipocurso:''))
                formData.append('celular', (this.curso.celular?this.curso.celular:''))
                formData.append('logradouro', (this.curso.logradouro?this.curso.logradouro:''))
                formData.append('numero', (this.curso.numero?this.curso.numero:''))
                formData.append('complemento', (this.curso.complemento?this.curso.complemento:''))
                formData.append('bairro', (this.curso.bairro?this.curso.bairro:''))
                formData.append('cidade', (this.curso.cidade?this.curso.cidade:''))
                formData.append('estado', (this.curso.estado && this.curso.estado != '0' ?this.curso.estado:''))
                formData.append('cep', (this.curso.cep?this.curso.cep:''))
                formData.append('urlapirubeus', (this.curso.urlapirubeus?this.curso.urlapirubeus:''))
                formData.append('tokenapirubeus', (this.curso.tokenapirubeus?this.curso.tokenapirubeus:''))
                formData.append('urlapigvdasa', (this.curso.urlapigvdasa?this.curso.urlapigvdasa:''))
                formData.append('tokenapigvdasa', (this.curso.tokenapigvdasa?this.curso.tokenapigvdasa:''))
                formData.append('ativo',(this.curso.ativo=='Ativo'?'1':'0'))
                if(this.tipoCadastro==2){
                    formData.append('nomereduzido', (this.curso.nomereduzido?this.curso.nomereduzido:''))
                }else{
                    formData.append('nomereduzido', '')
                }
                formData.append('email',(this.curso.email?this.curso.email:''))

                let configuracao = {
                    // method:'post',
                    // headers:{
                    //     // // 'Accept': 'application/json',
                    //     // // 'Authorization': this.$root.token(),
                    // }
                }
                
                axios.post(url,formData,configuracao)
                    .then(response => {
                        this.transacaoStatus = response.status
                        this.curso = response.data.usuarioNovo;
                        this.errors={};
                        this.curso.CadastroTipo=2
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response)
                    })
            // }
        },
        atualizaCompany(){
            // if(this.modonovo){
                let url='/api/v1/'+this.urlSistema+'/'+this.curso.id;
                console.log(url)
                //console.log(this.curso)                                  
                let formData = new FormData();
                formData.append('_method','patch');
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('codigoempresa', (this.curso.codigoempresa?this.curso.codigoempresa:''))
                formData.append('nomecompleto', (this.curso.nomecompleto?this.curso.nomecompleto:''))
                formData.append('cnpj', (this.curso.cnpj?this.curso.cnpj:''))
                formData.append('email', (this.curso.email?this.curso.email:''))
                formData.append('tipocurso', (this.curso.tipocurso?this.curso.tipocurso:''))
                formData.append('celular', (this.curso.celular?this.curso.celular:''))
                formData.append('logradouro', (this.curso.logradouro?this.curso.logradouro:''))
                formData.append('numero', (this.curso.numero?this.curso.numero:''))
                formData.append('complemento', (this.curso.complemento?this.curso.complemento:''))
                formData.append('bairro', (this.curso.bairro?this.curso.bairro:''))
                formData.append('cidade', (this.curso.cidade?this.curso.cidade:''))
                formData.append('estado', (this.curso.estado && this.curso.estado != '0' ?this.curso.estado:''))
                formData.append('cep', (this.curso.cep?this.curso.cep:''))
                formData.append('urlapirubeus', (this.curso.urlapirubeus?this.curso.urlapirubeus:''))
                formData.append('tokenapirubeus', (this.curso.tokenapirubeus?this.curso.tokenapirubeus:''))
                formData.append('urlapigvdasa', (this.curso.urlapigvdasa?this.curso.urlapigvdasa:''))
                formData.append('tokenapigvdasa', (this.curso.tokenapigvdasa?this.curso.tokenapigvdasa:''))
                formData.append('ativo',(this.curso.ativo=='Ativo'?'1':'0'))
                if(this.responsavel_id>0){
                    formData.append('responsavel_id', (this.responsavel_id))
                }
                if(this.tipoCadastro==2){
                    formData.append('nomereduzido', (this.curso.nomereduzido?this.curso.nomereduzido:''))
                }else{
                    formData.append('nomereduzido', '')
                }
                formData.append('email',(this.curso.email?this.curso.email:''))
                
                let configuracao = {
                    // method:'put',
                    // headers:{
                    // //     'Accept': 'application/json',
                    // //     'Authorization': this.$root.token()
                    // },
                }
                
                axios.post(url, formData,configuracao)
                    .then(response => {
                        // console.log(response)
                        this.transacaoStatus = response.status
                        this.curso = response.data.usuarioNovo;
                        this.errors={};
                        this.curso.CadastroTipo=2
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response.data)
                    })
            // }
        },
        exportarEmpresaCrm(unidade){
            let url='/api/v1/Companies/Company/CadastroLocaisOferta/'+this.curso.id;
                
                //console.log(this.curso)                                  
                
                
            let configuracao = {
                // method:'put',
                // headers:{
                // //     'Accept': 'application/json',
                // //     'Authorization': this.$root.token()
                // },
            }
            
            axios.post(url,configuracao)
                .then(response => {
                    this.empresa_exportada_crm = response.data
                    console.log(this.empresa_exportada_crm)
                    // this.empresa_exportada_crm.id = response.data.resposta_crm.id
                    $('#ExportacaoCrmMsg').modal('show');
                })
                .catch(errors => {
                    this.errors = errors.response.data.errors
                    console.log(errors.response.data)
                })
        },
        excluirUsuarioCliente(id){
            
            if(this.modoexcluir){
                var config = {
                method: 'delete',
                url: '/api/v1/'+this.urlSistema+'/'+id,
                // headers: {
                //         // 'Accept': 'application/json',
                //         // 'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    debugger;
                    // console.log(response.data.usuario)
                    this.$bvModal.hide('modal-prevent-closing')
                    this.$nextTick(() => {
                        window.alert("Usuário de Cliente excluído com sucesso");
                    })
                    this.removerPorId(id)
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
        formatDate(date,idioma) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            if(idioma==1){
                let dt = [year, month, day].join('-');
                if(dt=='1969-12-31'){
                    return null
                }else{
                    return dt;
                }
            }else if(idioma==2){
                let dt = [day, month, year].join('/');
                if(dt=='31/12/1969'){
                    return null
                }else{
                    return dt;
                }
            }else{
                let dt = [year, month, day].join('-');
                if(dt=='1969-12-31'){
                    return null
                }else{
                    return dt;
                }
            }
        },
    },
    mounted(){
        // this.$root.atualizaCookie('token');
    },
    created(){

        if(this.pessoa){
            this.curso = this.pessoa;
            console.log(this.curso)
            this.users = this.usuarios;
            this.doc=this.pessoa.cnpj;
            
            if(this.pessoa.responsavel_id>0){
                this.responsavel_id=this.pessoa.responsavel_id
            }

            if(this.pessoa.cnpj.length==14){
                this.curso.CadastroTipo=1
                this.curso.cnpj = this.pessoa.cnpj;
                this.tipoCadastro=1
            }else if(this.pessoa.cnpj.length==18){
                this.curso.CadastroTipo=2
                this.curso.cnpj = this.pessoa.cnpj;
                this.tipoCadastro=2
            }else{
                this.curso.CadastroTipo=2
                this.tipoCadastro=2
            }
        }else{
            this.curso.CadastroTipo=2;
            this.tipoCadastro=2;
            this.curso.estado="0";
        }
    },
    props:{
        urlSistema:{
            type:String,
            required:true
        },
        visualizar:{
            type:Boolean,
            required:true
        },
        nomeFormulario:{
            type:String,
            required:true
        },
        metodoFormulario:{
            type:String,
            required:true
        },
        linkAction:{
            type:String,
            required:true
        },
        pessoa:{
            type:Object,
            required:false
        },
        usuarioAutenticado:{
            type:Object,
            required:false
        },
        usuarios:[],
        edit:{
            type:Boolean,
            required:true
        }
    },
    watch: {
    // whenever question changes, this function will run
        texto_modal(newTexto, oldTtexto) {
            if (newTexto!=oldTtexto) {
                this.texto_modal=newTexto;
            }
        }
        ,tipoCadastro(newTipoCadastro, oldTipoCadastro) {
            if (newTipoCadastro!=oldTipoCadastro) {
                this.curso.CadastroTipo=newTipoCadastro;
                this.tipoCadastro=newTipoCadastro;
                this.errors={};
            }
        },
        doc(newdoc, olddoc) {
            if (newdoc!=olddoc) {
                this.curso.cnpj=newdoc;
                this.doc=newdoc;
            }
        },
    },
    data(){
        return{
            transacaoStatus:null,
            modonovo:false,
            modoeditar:false,
            modoexcluir:false,
            Novo:false,
            texto_modal:'',
            nameState: null,
            senhaState:null,
            emailState:null,
            submittedNames: [],
            tipoCadastro:null,
            doc:null,
            curso:{
                id:null,
                nomecompleto:null,
                nomereduzido:null,
                cnpj:null,
                logradouro:null,
                numero:null,
                complemento:null,
                cep:null,
                pais:null,
                estado:null,
                cidade:null,
                bairro:null,
                site:null,
                email:null,
                tipocurso:null,
                celular:null,
                codigoempresa:null,
                /**
                 * cpf = 1
                 * cnpj = 2
                 */
                CadastroTipo:0,
                // link_integracao_gvdasa:null,
                // token_api_gvdasa:null,
                // link_integracao_rubeus:null,
                // token_api_rubeus:null,
                // origem:null,

            },
            user:{
                id:null,
                name:null,
                email:null,
                senha:null,
            },
            responsavel_id:0,
            users:[],
            errors:{},
            empresa_exportada_crm:[{
                id:null,
                codigo:null,
                descricao:null,
                nome:null,
                oridem:null
            }],
        }
    }
}
</script>

<style scoped>
    form{
        text-align: left!important;
    }

    /* turmas vinculadas: o cartão (busca, ordenação, paginação) vem do v-ec-datatable */
    .cc-turmas{
        margin-top: 1.5rem;
        text-align: left;
    }

    .cc-turmas__titulo{
        display: flex;
        align-items: center;
        gap: .5rem;
        margin: 0 0 .75rem;
        font-size: 1rem;
        font-weight: 700;
        color: #1c4d5a;
    }

    .cc-turmas__contagem{
        padding: .1rem .55rem;
        border-radius: 999px;
        font-size: .75rem;
        font-weight: 600;
        color: #64767c;
        background: #f1f3f4;
        font-variant-numeric: tabular-nums;
    }

    /* modais de confirmação: tabela "rótulo: valor" */
    .cc-detalhes{
        text-align: left;
    }

    .cc-detalhes tbody th{
        width: 40%;
        font-size: .75rem;
        font-weight: 600;
        letter-spacing: .03em;
        text-transform: uppercase;
        color: #64767c;
        white-space: nowrap;
    }

    .cc-detalhes tbody td{
        font-weight: 600;
        overflow-wrap: anywhere;
    }
</style>
